import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate} from "react-intl";

class FormaterDate extends React.Component {

    otherProps = {};

    constructor(props) {
        super(props);

        let {value, ...otherProps} = this.props;
        this.otherProps = otherProps;

        this.state = {value};
    }

    render() {
        let {month, year, day, ...other} = this.otherProps;
        return (
            <FormattedDate
                value={this.state.value}
                day={day || "2-digit"}
                month={month || "2-digit"}
                year={year || "numeric"}
                {...other}
            />
        );
    }
}

FormaterDate.propTypes = {
    value: PropTypes.string
};

export default FormaterDate;



// WEBPACK FOOTER //
// ./resources/assets/js/components/Formater/Date.jsx